var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.selectedMembershipGroups.length > 0)?_c('ul',_vm._l((_vm.selectedMembershipGroups),function(group){return _c('li',{key:group.uuid,domProps:{"textContent":_vm._s(group.attributes.title)}})}),0):_c('span',{staticClass:"text-xs italic",domProps:{"textContent":_vm._s('None')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }